import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-news',
    imports: [],
    templateUrl: './news.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './news.component.scss'
})
export class NewsComponent {

}
